var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-6 flex-column-center"},[_c('h4',[_vm._v("\n    Tempo médio de agendamento de "+_vm._s(_vm.title)),_c('br'),_vm._v(" "),_c('small',[_vm._v("(últimos 6 meses)")])]),_vm._v(" "),_c('div',{staticClass:"chartWrapper"},[_c('PieChart',{attrs:{"chartData":_vm.chartData,"options":_vm.options}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6304f3f3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProcedimentosSaude/EstatisticaTempoMedio.vue
// module id = gqFd
// module chunks = 15